export default __webpack_public_path__ + "static/media/coming-soon.5a736d6a.png";